<template>
  <v-layout row>
    <v-dialog v-model="orderCategoriesDialog" max-width="550px">
      <v-toolbar-side-icon class="send-request-btn" slot="activator"></v-toolbar-side-icon>
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <v-card>
            <v-toolbar color="#5a65db" dark>
              <v-toolbar-title class="text-xs-center">{{$t('settings.ordering')}}</v-toolbar-title>

              <v-spacer></v-spacer>

            </v-toolbar>
            <v-list subheader>
              <draggable v-model="orderedCategories">
                <template v-for="(category, index) in orderedCategories" >
                  <v-list-tile
                    :key="index"
                    style="border: 1px solid #4ab5e0; margin: 2px"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title v-html="category.displayInfo.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </draggable>
            </v-list>
            <v-card-actions class="add-cancel-btn-sect">
              <v-btn flat class="cancel-new-category-btn" @click="closeOrderCategoryDialog">{{$t('close')}}</v-btn>
              <v-btn flat class="add-new-category-btn" @click="orderCategory">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex'
import Draggable from 'vuedraggable'

export default {
  name: 'CategoryOrdering',
  props: ['categories'],
  components: {
    Draggable
  },
  data: () => ({
    orderedCategories: [],
    orderCategoriesDialog: false
  }),
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    })
  },
  methods: {
    orderCategory () {
      let categories = []
      this.orderedCategories.forEach((cat, i) => {
        categories.push({id: cat.id, order: i})
      })
      this.$store.dispatch('categories/order', {categories: categories})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.editSubCategoryDialog = false
          }
        })
        .then(() => {
          this.closeOrderCategoryDialog()
        })
        .catch(console.error)
    },
    closeOrderCategoryDialog () {
      this.orderCategoriesDialog = false
    }
  },
  created () {
    if (this.$props.categories) {
      this.$props.categories.forEach((category, i) => {
        if (!category.order) {
          category.order = i
        }
        this.orderedCategories.push(category)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/CategoryOrdering.vue